import type { ProviderMatcher } from '../widgetMacroTypes.ts';

import { isSafeUrlMatch, withUnit } from '../utils/urlMatcherUtils.ts';

const HOST = 'www.google.com';
const PATH = '/calendar';

const DEFAULT_WIDTH = '800px';
const DEFAULT_HEIGHT = '600px';

export const matchGoogleCalendar: ProviderMatcher = (url, params) => {
	if (!isSafeUrlMatch(url, HOST, PATH)) {
		return null;
	}
	return {
		kind: 'iframe',
		provider: 'Google Calendar',
		embedUrl: url,
		width: withUnit(params.width) ?? DEFAULT_WIDTH,
		height: withUnit(params.height) ?? DEFAULT_HEIGHT,
	};
};
